<template>
    <section class="Element Overview Users default">
        <div class="row">
            <div class="col-sm-5">
                <div class="Heading">
                    <h3 class="h3">{{ trans("Gebruikers") }}</h3>
                    <div class="Intro">
                        <p>{{ trans("Welkom op jouw gebruikersdashboard. Beheer eenvoudig accounts, stel rollen in, en houd overzicht over alle actieve systemen binnen jouw organisatie. Klik op '+ Toevoegen' knop om een nieuwe gebruiker toe te voegen of stel de gebruikersrol in via het dropdownmenu.") }}</p>
                    </div>
                    <Actions v-if="viewData.workflowcard_id" :key="viewData.workflowphase_id" />
                    <WorkflowcardAdd v-if="!viewData.workflowcard_id && viewData.workflowboard_id" :workflowboard_id="viewData.workflowboard_id" />
                </div>
            </div>
            <div class="col-sm-7">
                <template v-if="viewData.workflowphase_id">
                    <workflowphase-list
                        layout="list"
                        :workflowboard_id="viewData.workflowboard_id"
                        :workflowphase_id="viewData.workflowphase_id"
                        :related_filter_json="viewData.extra_filters"
                        :key="viewData.overview_ticker"
                        :icon_buttons_by_role="true"
                    >
                        <template #workflowcard_item_actions="{ data, layout }">
                            <el-dropdown placement="bottom-end" size="large" split-button v-for="roleProperty in roleProperties" :disabled="role_disabled(data)">
                                {{ resolveProperty(data, roleProperty.id)?.value ?? trans("Selecteer rol") }}
                                <template #dropdown>
                                    <el-dropdown-menu>
                                        <el-dropdown-item v-for="(option, key) in roles(roleProperty)" @click.prevent="handleRole(data, roleProperty, option)">
                                            {{ option }}
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </template>
                            </el-dropdown>
                        </template>
                    </workflowphase-list>
                </template>
                <template v-else>
                    <workflowphase-overview
                        v-if="viewData.workflowboard_id"
                        layout="list"
                        :workflowboard_id="viewData.workflowboard_id"
                        :workflowphase_id="viewData.workflowphase_id"
                        :related_filter_json="viewData.extra_filters"
                        :key="viewData.overview_ticker"
                    >
                        <template #workflowcard_item_actions="{ data, layout }">
                            <el-dropdown placement="bottom-end" size="large" split-button v-for="roleProperty in roleProperties" :disabled="role_disabled(data)">
                                {{ resolveProperty(data, roleProperty.id)?.value ?? trans("Selecteer rol") }}
                                <template #dropdown>
                                    <el-dropdown-menu>
                                        <el-dropdown-item v-for="(option, value) in JSON.parse(roleProperty.options_json)" @click.prevent="handleRole(data, roleProperty, value)">
                                            {{ option }}
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </template>
                            </el-dropdown>
                        </template>
                    </workflowphase-overview>
                </template>
            </div>
        </div>
    </section>
</template>

<script>
import {defineComponent, inject, computed, reactive, ref} from "vue";

import Popup from "components/popup";


import Dropdown from "components/dropdown";
import Icon from "components/icon";

import trans from "helpers/_translation";
import { env } from "config";

import { addNotification } from "store/notifications";

import Actions from "components/workflowcard/actions";
import WorkflowcardAdd from "view/dashboard/includes/workflowcard-add";

import workflowphaseList from "view/dashboard/includes/workflowphase-list";
import workflowphaseOverview from "view/dashboard/includes/workflowphase-overview";

import { contact, lower_roles, rolePropertyNames, role_disabled, value, user_avatar } from "store/portal";
import { getWorkflowpropertiesByNames, resolveProperty } from "store/workflow";

import {setWorkflowpropertyfield} from "helpers/_workflowpropertyfield";

export default defineComponent({
    name: "part",
    props: {

    },
    components: {
        Icon,
        Popup,
        Dropdown,

        Actions,
        WorkflowcardAdd,

        workflowphaseList,
        workflowphaseOverview
    },
    setup() {

        const viewData = inject("viewData");


        const roleProperties = computed(() => {
            return getWorkflowpropertiesByNames(rolePropertyNames.value);
        });
        const roles = (roleProperty) => {
            return computed(() => {
                const result = JSON.parse(roleProperty.options_json);
                // Filter items by key, only keep lower_roles
                return Object.keys(result).filter(key => lower_roles.value.includes(key)).map(key => result[key]);
            }).value;
        };

        const handleRole = (data, property, value) => {
            // Not allowed to change role
            if (role_disabled(data)) return;
            // Set role
            setWorkflowpropertyfield(data, data.id, property, value);
            addNotification(trans("Gebruikersrol is ingesteld."), 3500);
        };

        return {
            env,
            value,

            viewData,

            user_avatar,
            contact,
            trans,

            roleProperties,
            resolveProperty,

            roles,
            role_disabled,

            handleRole
        };
    },
});
</script>